<template>
  <v-row v-if="!$_.isEmpty(filterOptions)">
    <v-col>
      <v-row class="align-center">
        <v-btn
          ref="filter_btn"
          color="blue"
          depressed
          @click.stop="toggleFilterBox"
        >
          <v-icon>
            filter_list
          </v-icon>
        </v-btn>
        <v-chip
          v-if="Object.keys(activeFilters).length"
          color="blue"
          text-color="white"
        >
          {{ Object.keys(activeFilters).length }}
        </v-chip>
      </v-row>
    </v-col>

    <v-menu
      :value="showFilter"
      :position-x="posBoxX"
      :position-y="posBoxY"
      :close-on-content-click="false"
      :min-width="selectedOption ? 516 : 234"
    >
      <v-row class="mx-0">
        <v-col :cols="selectedOption ? 6 : 12">
          <v-list
            dense
          >
            <v-list-item-group
              color="blue"
            >
              <v-list-item
                v-for="(opt, name) in options"
                :key="name"
                class="pl-1"
                :input-value="selectedOption !== null && selectedOption.key == name"
                @click="setSelectedOption(opt, name)"
              >
                <v-chip
                  class="mr-2"
                  :color=" Object.keys(activeFilters).indexOf(name) > -1 ? 'blue' : 'lightgrey'"
                  :text-color="Object.keys(activeFilters).indexOf(name) > -1 ? 'white' : 'black'"
                >
                  {{ Object.keys(activeFilters).indexOf(name) > -1 ? options[name].type === 'multi' ? options[name].filter.length : 1 : 0 }}
                </v-chip>
                <v-list-item-content>
                  <v-list-item-title v-text="opt.label" />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-row
            class="mx-0"
          >
            <v-col
              cols="6"
              class="pa-0 d-flex flex-column"
            >
              <v-btn
                color="red"
                @click="clearFilters"
              >
                {{ $t('clear') }}
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="pa-0"
            >
              <v-btn
                color="blue"
                @click="setFilters"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="selectedOption !== null"
          cols="6"
        >
          <filter-range
            v-if="selectedOption.type === 'range'"
            :key="selectedOption.key"
            :filter-name="selectedOption.key"
            :from-value="selectedOption.filter.from"
            :to-value="selectedOption.filter.to"
            @filter-added="addFilter"
            @filter-remove="removeFilter"
          />
          <filter-date-range
            v-if="selectedOption.type === 'date-range'"
            :key="selectedOption.key"
            :filter-name="selectedOption.key"
            :from-value="selectedOption.filter.from"
            :to-value="selectedOption.filter.to"
            @filter-added="addFilter"
            @filter-remove="removeFilter"
          />
          <filter-multi
            v-if="selectedOption.type === 'multi' && selectedOption.options && selectedOption.options.length"
            :key="selectedOption.key"
            :selected-values="selectedOption.filter"
            :filter-name="selectedOption.key"
            :filter-options="selectedOption.options"
            @filter-added="addFilter"
            @filter-remove="removeFilter"
          />
          <filter-single
            v-if="selectedOption.type === 'single' && selectedOption.options && selectedOption.options.length"
            :key="selectedOption.key"
            :selected-value="selectedOption.filter"
            :filter-name="selectedOption.key"
            :filter-options="selectedOption.options"
            @filter-added="addFilter"
            @filter-remove="removeFilter"
          />
          <filter-free-text
            v-if="selectedOption.type === 'free'"
            :key="selectedOption.key"
            :filter-name="selectedOption.key"
            :filter-value="selectedOption.filter"
            @filter-added="addFilter"
            @filter-remove="removeFilter"
          />
        </v-col>
      </v-row>
    </v-menu>
  </v-row>
</template>

<script>
  export default {
    props: {
      filter: {
        type: Object,
        default () {
          return {}
        },
      },
      filterOptions: {
        type: Object,
        default () {
          return {}
        },
      },
      filterActions: {
        type: Array,
        default () {
          return []
        },
      },
    },
    data () {
      return {
        showFilter: false,
        selectedOption: null,
        activeFilters: {},
        options: {},
        posBoxX: 0,
        posBoxY: 0,
      }
    },
    watch: {
      filter: function () {
        this.activeFilters = this.filter
      },
      selectedOption: function () {
        // this.selectedOption
      },
    },
    mounted: function () {
      this.options = this.filterOptions
      this.activeFilters = this.filter

      this.$_.each(this.filter, (i, key) => {
        this.options[key].filter = i
      })
    },
    methods: {
      toggleFilterBox: function (ev) {
        this.selectedOption = null
        this.showFilter = !this.showFilter

        if (this.showFilter) { this.calcPosOfBox(ev) }
      },
      setSelectedOption: function (opt, key) {
        this.selectedOption = { ...opt, key }
      },
      getLabel: function (opt, key) {
        let returnString = `<p> ${opt.label}`

        if (Object.keys(this.activeFilters).indexOf(key) > -1) {
          const number = this.options[key].type === 'multi' ? this.options[key].filter.length : 1
          returnString += `<span class="new badge blue" data-badge-caption="">${number}</span>`
        }
        returnString += ' </p>'
        return returnString
      },
      addFilter: function (filter) {
        const key = Object.keys(filter)[0]

        this.options[key].filter = filter[key]

        this.activeFilters = { ...this.activeFilters, ...filter }
        this.selectedOption = null
      },
      removeFilter: function (filter) {
        delete this.activeFilters[filter]

        this.selectedOption = null
      },
      clearFilters: function () {
        this.activeFilters = {}
        this.$emit('set-filter', this.activeFilters)
        this.toggleFilterBox()
      },
      setFilters: function () {
        this.$emit('set-filter', this.activeFilters)
        this.toggleFilterBox()
      },
      calcPosOfBox (ev) {
        const btn = this.$_.find(ev.path, p => p.localName === 'button')
        if (!btn) { return }
        const boundingRect = btn.getBoundingClientRect()

        this.posBoxX = boundingRect.left
        this.posBoxY = boundingRect.bottom + 10
      },

    },
  }
</script>
